import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = {amounts: [], total: ''}

const state = {
  weather: startState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.weather = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.weather = startState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.weather
}

export const Weather = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/barCharts/Weather.js